import { render, staticRenderFns } from "./ShipOrderToStore.vue?vue&type=template&id=2c900ca8"
import script from "./ShipOrderToStore.vue?vue&type=script&lang=js"
export * from "./ShipOrderToStore.vue?vue&type=script&lang=js"
import style0 from "./ShipOrderToStore.vue?vue&type=style&index=0&id=2c900ca8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports